export default __webpack_public_path__ + "static/folkov-logo-861a65b5c238b2b6e770a94162520766.png";